export default __webpack_public_path__ + "static/media/check-circle.4ebb3c9d.svg";